module.exports = __webpack_public_path__ + "static/img/photosensitive-01.a83b2e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/photosensitive-01.jpg
// module id = 284
// module chunks = 1